package navigation.home.task.alltasks

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.client.domain.repository.ClientRepository
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.profile.domain.repository.ProfileRepository
import com.essntl.features.service.domain.repository.ServiceRepository
import com.essntl.features.task.domain.repository.TaskRepository
import com.essntl.features.task.domain.use_case.UpdateTaskUseCase
import com.essntl.features.task.ui.alltasks.AllTasksEvent
import com.essntl.features.task.ui.alltasks.AllTasksState
import com.essntl.features.task.ui.alltasks.AllTasksViewModel

class AllTasksScreenModel(
    taskRepository: TaskRepository,
    itineraryRepository: ItineraryRepository,
    categoryRepository: CategoryRepository,
    profileRepository: ProfileRepository,
    updateTaskUseCase: UpdateTaskUseCase,
    loadingManager: LoadingManager,
) : StateScreenModel<AllTasksState>(AllTasksState()) {

    private val allTasksViewModel =
        AllTasksViewModel(
            taskRepository = taskRepository,
            itineraryRepository = itineraryRepository,
            categoryRepository = categoryRepository,
            profileRepository = profileRepository,
            updateTaskUseCase = updateTaskUseCase,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AllTasksEvent) {
        allTasksViewModel.onEvent(event)
    }
}
